module.exports = __webpack_public_path__ + "img/logo_red.970aad6f.png";